
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Templates provide users with examples of how components can be used together on a page. They can help users display their project and understand how its layout can best meet their needs.`}</p>
    <p>{`The templates we use are built using HTML/CSS only. The layouts are flexible, to take account of your needs; the only exceptions are the site header and footer, which are standardised. Users can choose those components that best convey the messages they want to send to their audience.`}</p>
    <p>{`Europa.eu standard template is work in progress.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;